import React from 'react'

// import { motion, AnimatePresence } from "framer-motion";

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

class Item extends React.Component{

    constructor (props) {
        super(props);
        this.state = {visible: true}
    }

    setVisible = (id) => {
        this.setState({visible: false});
        this.props.removeItem(id)
    }

    render () {
        return (
            <div>
                {this.state.visible && (
                    <div>
                        <ListItem className="list-item">
                            <ListItemAvatar>
                                <Avatar className="cart-item-avatar">
                                    <img alt="something graphical" src={this.props.item?.image} />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={this.props.item?.title} secondary={`$${this.props.item?.price}`} />
                            <ListItemSecondaryAction className="list-right-side">
                                <ListItemText secondary="July 20, 2014" />
                                <IconButton onClick={(e) => this.setVisible(this.props.item?.id)}  edge="end" aria-label="delete">
                                    <DeleteIcon />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    </div>
                )}
            </div>
        )
    }
}

export default Item
